import { render, staticRenderFns } from "./TempleVideo.vue?vue&type=template&id=2c9b8e61"
import script from "./TempleVideo.vue?vue&type=script&lang=js"
export * from "./TempleVideo.vue?vue&type=script&lang=js"
import style0 from "./TempleVideo.vue?vue&type=style&index=0&id=2c9b8e61&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports